<template>
    <div>
        <p @click="active = !active" style="cursor: pointer"><v-icon :color="entityConfig.primaryColor">{{arrow}}</v-icon>{{checkboxData.text}}</p>
        <slide-up-down :active="active" :duration="300">
           <iframe title="Terminos" :src="checkboxData.url" width="100%" :height="checkboxData.height" frameborder="0"></iframe>
        </slide-up-down>
        <v-checkbox style="width: auto !important" @click="emitState()" :color="entityConfig.primaryColor" v-model="checked">
            <template v-slot:label>
                <div v-html="checkboxData.label"></div>
            </template>
        </v-checkbox>
    </div>
</template>

<script>
export default {
    props:  {
        checkboxData: {
            type: Object,
            default() {
                return { type: 'raw-html' }
            }
        },
        externalExpandedState: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        checked: false,
        active: false,
        entityConfig: {},
    }),
    mounted() {
        this.entityConfig = this.$store.state.entityConfig.config;
        console.log(this.externalExpandedState);
    },
    watch: {
        externalExpandedState: function(oldVal, newVal) {
            this.active = newVal;
        }
    },
    computed: {
        arrow() {
            return this.active ? 'mdi-chevron-down' :  'mdi-chevron-right';
        }
    },
    methods: {
        emitState() {
            let state = this.checked ? "accepted" : "canceled";
            this.$emit(state);
        }
    }
}
</script>
